module.exports = __webpack_public_path__ + "static/sport/bgi-h5.ca8b2d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-h5.jpg
// module id = ugzP
// module chunks = 0